// extracted by mini-css-extract-plugin
module.exports = {"ButtonDiv":"DisablePopUp_ButtonDiv_3WgI2"};